import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Socket } from 'src/interfaces';

const initialState: Socket = {
    socketConnection: null,
    pdfSocketConnection: null,
    version: 'v0',
    // loading: false,
    // textQuery: '',
};

export const socketSlice = createSlice({
    name: 'socket',
    initialState,
    reducers: {
        setSocketConnection: (state: Socket, action: PayloadAction<WebSocket | null>) => { state.socketConnection = action.payload },
        setPdfSocketConnection: (state: Socket, action: PayloadAction<WebSocket | null>) => { state.pdfSocketConnection = action.payload },
        serVersion: (state: Socket, action: PayloadAction<'v0' | 'v1'>) => { state.version = action.payload },
    },
});

export const { setSocketConnection, setPdfSocketConnection, serVersion } = socketSlice.actions;

export default socketSlice.reducer;